import * as React from 'react'
import { connect } from 'react-redux'

import { applicationValidate } from 'embed/actions/application'
import { Offer } from 'embed/constants/models'
import { applicationStateSelector } from 'embed/selectors/application'
import { OfferType, Product, ProductStep } from '@evenfinancial/even-ts-static'
import ApplicationSubmitButton from './index'

export interface OwnProps {
  children?: React.ReactNode
  fullWidth?: boolean
  handleBeforeSubmit?: () => void
  nextStep?: ProductStep
  offer?: Offer
  offerType?: OfferType
  product: Product
}

export interface Props extends OwnProps {
  onSubmit: () => void
  isValid: boolean
}

const mapDispatchToProps = (dispatch, ownProps: OwnProps) => ({
  onSubmit: () => {
    ownProps.handleBeforeSubmit?.()
    dispatch(applicationValidate(ownProps.product, ownProps.nextStep, ownProps.offer, ownProps.offerType))
  },
})

const mapStateToProps = (state, ownProps: OwnProps) => ({
  isValid: applicationStateSelector(state)[ownProps.product]?.isValid,
})

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationSubmitButton)
